import { useDarkMode } from '@/contexts/DarkModeContext';
import AnySkillLogo from './AnySkillLogo';

const DarkModeTransition = () => {
  const { isTransitioning, isDarkMode } = useDarkMode();

  if (!isTransitioning) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-background/95 backdrop-blur-sm flex items-center justify-center">
      <div className="text-center space-y-4">
        <div className="animate-spin mx-auto">
          <AnySkillLogo size={48} />
        </div>
        <p className="text-foreground font-medium">
          Switching to {isDarkMode ? 'Light' : 'Dark'} Mode...
        </p>
      </div>
    </div>
  );
};

export default DarkModeTransition;